import React from "react";
import { Row, Col, Card, Typography, Statistic, Space } from "antd";

const { Title, Paragraph } = Typography;
const { Countdown } = Statistic;

export interface ComingSoonSectionProps {
  title?: string;
  subtitle?: string;
  launchDate?: string | number | Date; // ISO string, timestamp, or Date
  showCountdown?: boolean;
  backgroundImage?: string;
  className?: string;
}

/**
 * ComingSoonSection
 * - Ant Design + TypeScript single-file component
 * - Responsive layout with optional countdown
 */
export default function ComingSoonSection({
  title = "Coming Soon",
  subtitle = "We're working hard to bring something great. Stay tuned for the launch.",
  launchDate,
  showCountdown = true,
  backgroundImage,
  className,
}: ComingSoonSectionProps) {
  const cardStyle: React.CSSProperties = {
    borderRadius: 12,
    padding: 24,
    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
    background: "rgba(255,255,255,0.95)",
    minHeight: 200,
  };

  const containerStyle: React.CSSProperties = backgroundImage
    ? {
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "56px 24px",
        borderRadius: 16,
      }
    : { padding: "56px 24px" };

  return (
    <div className={className} style={containerStyle}>
      <Row justify="center">
        <Col xs={24} sm={20} md={16} lg={12} xl={10}>
          <Card style={cardStyle} bordered={false}>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
              <div>
                <Title
                  className=" text-green-500"
                  level={2}
                  style={{ margin: 0 }}
                >
                  {title}
                </Title>
                <Paragraph style={{ marginTop: 8 }}>{subtitle}</Paragraph>
              </div>

              {showCountdown && launchDate ? (
                <div style={{ textAlign: "center" }}>
                  <Countdown
                    title="Launch in"
                    value={new Date(launchDate).getTime()}
                    format="D [days] HH:mm:ss"
                    style={{ fontSize: 22 }}
                  />
                </div>
              ) : null}
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
